<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="90px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="工厂编号" class="EL-Form-Item">
                        <el-select
                        multiple
                        collapse-tags
                        v-model="selectedFcList"
                        filterable
                        clearable="clearable"
                        >
                        <el-option
                            v-for="item in factoryList"
                            :key="item.fcCode"
                            :value="item.fcCode"
                            :label="item.fcCode"
                            >{{ item.fcCode }}</el-option
                        >
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.lcCode" clearable="clearable">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.lcName" clearable="clearable">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="所属通道" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.whCode" clearable="clearable">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位类型" class="EL-Form-Item">
                        <el-select v-model="pagination.lcType" filterable placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in dictDataList" :key="item.ddId" :label="item.ddCode+'-'+item.ddName" :value="item.ddCode">{{item.ddCode}}-{{item.ddName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>       
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位状态" class="EL-Form-Item">
                        <el-select v-model="pagination.lcStatus" placeholder="请选择" clearable="clearable">
                            <el-option label="正常" value="NORMAL"> </el-option>
                            <el-option label="冻结" value="FREEZE"> </el-option>
                            <el-option label="警告" value="ALARM"> </el-option>
                            <el-option label="异常" value="WARNING"> </el-option>
                            <el-option label="分配" value="DISTR"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="库位">
                <el-button v-authority="'BACK_MENU5_M6_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">
                    新增
                </el-button>
                <el-button v-authority="'BACK_MENU5_M6_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal">
                <el-table-column prop="fcCode" label="工厂编号" />
                <el-table-column prop="whCode" label="所属通道" />
                <el-table-column prop="lcCode" label="库位编号" />
                <el-table-column prop="lcName" label="库位名称" />
                <el-table-column prop="lcAttr" label="库位属性" />
                <el-table-column prop="lcType" label="库位类型" />
                <el-table-column prop="lcSpecs" label="库位规格" />
                <!-- <el-table-column prop="waCode" label="所属库区" /> -->
                <el-table-column prop="lcX" label="库位位置 X" />
                <el-table-column prop="lcY" label="库位位置 Y" />
                <el-table-column prop="lcRange" label="库位距离" />
                <el-table-column prop="lcOccupy" label="是否占用">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lcOccupy == true">是</span>
                        <span v-if="scope.row.lcOccupy == false">否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lcStatus" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lcStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.lcStatus == 'FREEZE'">冻结</span>
                        <span v-if="scope.row.lcStatus == 'ALARM'">警告</span>
                        <span v-if="scope.row.lcStatus == 'WARNING'">异常</span>
                        <span v-if="scope.row.lcStatus == 'DISTR'">分配</span>
                    </template>
                </el-table-column>
                <el-table-column prop="parentCode" label="父库位"></el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU5_M6_B2'" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU5_M6_B3'" type="danger" @click="deleteRow(scope.row.lcId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" :style="$popups.popups(0.5,0.75)" class="fromDialog" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="工厂编号" class="EL-Form-Item">
                            <el-select v-model="mainObj.fcCode" placeholder="请选择" clearable="clearable">
                                <el-option v-for="item in fcCodeList" :key="item.fcCode" :label="item.fcCode" :value="item.fcCode">{{item.fcCode}}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库位编号" prop="lcCode" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.lcCode" maxlength="10"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库位名称" prop="lcName" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.lcName" maxlength="50"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库位属性" prop="lcAttr" class="EL-Form-Item">
                            <el-input v-model="mainObj.lcAttr"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库位类型" prop="lcType" class="EL-Form-Item">
                            <el-select v-model="mainObj.lcType" filterable placeholder="请选择">
                                <!-- <el-option key="" label=""></el-option> -->
                                <el-option v-for="item in dictDataList" :key="item.ddId" :label="item.ddCode+'-'+item.ddName" :value="item.ddCode">{{item.ddCode}}-{{item.ddName}}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库位规格" prop="lcSpecs" class="EL-Form-Item">
                            <el-input v-model="mainObj.lcSpecs"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="所属通道" prop="whCode" class="EL-Form-Item">
                            <el-select filterable v-model="mainObj.whCode" placeholder="请选择" clearable="clearable">
                                <el-option v-for="item in whCodeList" :key="item.whId" :label="item.whCode +' - ' + item.whName" :value="item.whCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库位位置 X" prop="lcX" class="EL-Form-Item">
                            <el-input v-model="mainObj.lcX" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库位位置 Y" prop="lcY" class="EL-Form-Item">
                            <el-input v-model="mainObj.lcY" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库位距离" prop="lcRange" class="EL-Form-Item">
                            <el-input v-model="mainObj.lcRange" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="状态" prop="lcStatus" class="EL-Form-Item">
                            <el-select v-model="mainObj.lcStatus" placeholder="请选择">
                                <el-option label="正常" value="NORMAL"> </el-option>
                                <el-option label="冻结" value="FREEZE"> </el-option>
                                <el-option label="警告" value="ALARM"> </el-option>
                                <el-option label="异常" value="WARNING"> </el-option>
                                <el-option label="分配" value="DISTR"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="父库位" prop="parentCode" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.parentCode" maxlength="10"> </el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="editBoxShow = false">取 消</el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">新 增</el-button>
                <el-button size="small" type="primary" v-else @click="editRow">修 改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "StockCheckTaskDetail",
    data() {
        return {
            headerCellStyle: () => {
                return "background-color: #1f5cec";
            },
            form: {},
            rules: {
                lcCode: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                lcName: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                lcStatus: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                parentCode: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
            },
            showRoleBox: true,
            add_or_edit: Boolean, //新增|编辑
            loading: 0, //加载中
            editBoxShow: false, //编辑框
            dialogFormVisible: false,
            formLabelWidth: "140px", // 对话框大小
            tableHeight: 0, //表格高度
            testValue: 1,
            mainObj: {
                lcCode: "",
                lcName: "",
                lcAttr: "",
                lcType: "",
                fcCode: localStorage.getItem("fcCode") || "",
                lcSpecs: "",
                whCode: localStorage.getItem("whCode") || "",
                waCode: "",
                lcX: "",
                lcY: "",
                lcRange: "",
                lcStatus: "",
                parentCode:"",
            },
            pagination: {
                pageSize: 50,
                pageNum: 1,
                lcCode: "",
                lcName: "",
                fcCode: localStorage.getItem("fcCode") || "",
                whCode: "",
                waCode: "",
                lcStatus: "",
                lcType: "",
            },
            tableTotal:0,
            mainData: [],
            whCodeList: [],
            waCodeList: [],
            dictDataList: [],
            fcode: localStorage.getItem("fcCode") || "",
            whCode: localStorage.getItem("whCode") || "",

            downloadLoading: false, //下载中

            logContent: "", //操作日志-内容
            logRemarks: "", //操作日志-备注
            // 输入框延时加载
            isSetTimeout: null,

            //选中的工厂
            selectedFcList: [],
            factoryList: [],
            fcCodeList: [],
        };
    },
    watch: {
        pagination: {
            handler(newVal) {
                clearTimeout(this.isSetTimeout)
                this.isSetTimeout = setTimeout(() => {
                    this.getAuxiMaterialData(newVal);
                }, 1000)
            },
            deep: true,
        },
        selectedFcList: {
            handler(newVal) {
                clearTimeout(this.isSetTimeout);
                this.isSetTimeout = setTimeout(() => {
                    this.getAuxiMaterialData(newVal);
                }, 1000);
            },
            deep: true,
        },
    },
    methods: {
        //获取数据
        getAuxiMaterialData() {
            var fcCode = "";
            this.selectedFcList.forEach((item) => {
                fcCode += item + ",";
            });
            this.pagination.fcCode = fcCode;
            this.$http
                .request({
                    url: "/api/location/getLocationAll",
                    method: "GET",
                    params: this.pagination,
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.mainData = resp.data.list || [];
                        this.tableTotal = resp.data.total;
                    }
                })
                .catch((error) => {
                    this.loading++;
                });
        },

        getFactory() {
            this.selectedFcList[0] = localStorage.getItem("fcCode");

            let fcCodes = null;
            let userFcCode = localStorage.getItem("fcCode") || null;

            // if (userFcCode == "YL" || userFcCode == "SY") {
            //     fcCodes = userFcCode;
            // }

            this.$http
                .request({
                    url: "/api/factory/getFactoryAll",
                    method: "GET",
                    params: {
                        fcCode: fcCodes,
                    },
                })
                .then((res) => {
                    if (res.status == 100) {
                        this.factoryList = res.data.list || [];
                    } else {
                        this.$message.error("错误");
                    }
                });
        },

        // 获取工厂
        getFactoryList() {
            let fcCodes = null;
            let userFcCode = localStorage.getItem("fcCode") || null;

            if (userFcCode == "YL" || userFcCode == "SY") {
                fcCodes = userFcCode;
            }

            this.$http
                .request({
                    url: "/api/factory/getFactoryAll",
                    method: "GET",
                    params: {
                        fcCode: fcCodes,
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.fcCodeList = resp.data.list || [];
                    }
                })
                .catch((error) => {
                    this.loading++;
                });
        },

        //表单验证
        submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    r = true;
                } else {
                    r = false;
                }
            });
            return r;
        },
        //框打开
        open() {
            if (this.add_or_edit) {
                //新增
                this.mainObj = JSON.parse(JSON.stringify({}));
            } else {
                this.getAuxiMaterialData();
            }
        },
        //新增
        add() {
            // this.mainObj.fcCode = this.fcode;
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/location/insertLocation",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.logRemarks = "location：库位新增成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: "新增失败",
                            });
                            this.logRemarks = "location：库位新增失败";
                        }
                        this.logContent = JSON.stringify(this.mainObj)
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getAuxiMaterialData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //编辑
        editRow() {
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/location/updateLocation",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "修改成功！",
                                type: "success",
                            });
                            this.logRemarks = "location：库位编辑成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: "修改失败",
                            });
                            this.logRemarks = "location：库位编辑失败";
                        }
                        this.logContent =
                            "lcCode：" +
                            this.mainObj.lcCode +
                            "\t lcName" +
                            this.mainObj.lcName;
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getAuxiMaterialData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //删除
        deleteRow(lcId) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/api/location/deleteLocation",
                            method: "DELETE",
                            showLoading: true,
                            params: {
                                lcId: lcId,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "删除成功！",
                                    type: "success",
                                });
                                this.logRemarks = "location：库位删除成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "删除失败",
                                });
                                this.logRemarks = "location：库位删除失败";
                            }
                            this.logContent = "lcId：" + lcId;
                            this.systemLog();
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },

        //获取通道
        getWhCode() {
            this.$http
                .request({
                    url: "/api/warehouse/getWarehouseAll",
                    method: "GET",
                    params: {
                        pageSize: 0,
                        pageNum: 0,
                        whCode: "",
                        whName: "",
                        fcCode: localStorage.getItem("fcCode") || "",
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.whCodeList = resp.data.list || [];
                    }
                })
                .catch((error) => {
                    this.loading++;
                });
        },
        //获取库位类型
        getDictData() {
            this.$http
                .request({
                    url: "/api/dictData/getDictData",
                    method: "GET",
                    params: {
                        ddCode: "LATYPE",
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        console.log(resp.data.list);
                        this.dictDataList = resp.data.list || [];
                    }
                })
                .catch((error) => {
                    this.loading++;
                });
        },
        // //获取库区
        // getWaCode() {
        //     this.$http
        //         .request({
        //             url: "/api/warearea/getWareareaAll",
        //             method: "GET",
        //             showLoading: true,
        //             params: {
        //                 pageSize: 0,
        //                 pageNum: 0,
        //                 waCode: "",
        //                 waName: "",
        //                 whCode: localStorage.getItem("whCode") || "",
        //                 fcCode: localStorage.getItem("fcCode") || "",
        //             },
        //         })
        //         .then((resp) => {
        //             if (resp.status == 100) {
        //                 this.waCodeList = resp.data.list || [];
        //             }
        //         })
        //         .catch((error) => {
        //             this.loading++;
        //         });
        // },

        //重置
        resetData() {
            this.pagination = {
                pageSize: 50,
                pageNum: 1,
                lcCode: "",
                lcName: "",
                fcCode: localStorage.getItem("fcCode") || "",
                whCode: "",
                waCode: "",
                lcStatus: "",
                lcType: "",
            };
            this.tableTotal=0;
            // this.getAuxiMaterialData();
        },

        //表格导出
        downLoadFile() {
            this.downloadLoading = true;
            var fcCode = "";
            this.selectedFcList.forEach((item) => {
                fcCode += item + ",";
            });
            var paramsObj = {
                lcCode: this.pagination.lcCode,
                lcName: this.pagination.lcName,
                fcCode: fcCode,
                whCode: this.pagination.whCode,
                waCode: this.pagination.waCode,
                lcStatus: this.pagination.lcStatus,
                lcType: this.pagination.lcType,
                pageNum: 1,
                pageSize: 999999,
            }

            this.$http.request({
                url: '/api/location/getLocationAll',
                method: 'GET',
                showLoading: true,
                params: paramsObj
            }).then((resp) => {
                resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                    message: '查询失败'
                });
            })
        },
        downLoad(list) {
            import('@/libs/Export2Excel').then(excel => {
                list.forEach(function(c) {
                    if (c.lcOccupy == true) {
                        c['lcOccupy'] = '是'
                    } else if (c.lcOccupy == false) {
                        c['lcOccupy'] = '否'
                    }

                    if (c.lcStatus == 'NORMAL') {
                        c['lcStatus'] = '正常'
                    } else if (c.lcStatus == 'FREEZE') {
                        c['lcStatus'] = '冻结'
                    } else if (c.lcStatus == 'ALARM') {
                        c['lcStatus'] = '警告'
                    } else if (c.lcStatus == 'WARNING') {
                        c['lcStatus'] = '异常'
                    } else if (c.lcStatus == 'DISTR') {
                        c['lcStatus'] = '分配'
                    }
                })
                const tHeader = ['工厂编号','所属通道', '库位编号', '库位名称', '库位属性', '库位类型', '库位规格', '库位位置 X', '库位位置 Y', '库位距离', '是否占用', '状态']
                const filterVal = ['fcCode','whCode', 'lcCode', 'lcName', 'lcAttr', 'lcType', 'lcSpecs', 'lcX', 'lcY', 'lcRange', 'lcOccupy', 'lcStatus']
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: '库位数据'
                })
                this.logContent = "导出"
                this.logRemarks = "sys_location：导出库位数据"
                this.systemLog();
                this.downloadLoading = false
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },


        /**
         * 操作日志
         */
        systemLog() {
            let objData = {
                logType: "库位主数据",
                logContent: this.logRemarks || "",
                //logRemarks: this.logRemarks || "",
                logUser: localStorage.getItem("user") || "",
            };
            this.$http
                .request({
                    url: "api/log/insert",
                    method: "POST",
                    data: objData,
                })
                .then((resp) => {
                    this.logContent = "";
                    this.logRemarks = "";
                    if (resp.status == 100) {}
                })
                .catch((error) => {});
        },
    },
    activated(){
        this.getDictData();
        this.getWhCode();
        /* 获取首页的数据 */
        this.getAuxiMaterialData();
        this.getFactory();
        this.getFactoryList();
    },
};
</script>

<style scoped>
</style>